import { useState } from 'react';
import { color, s8sColor } from '../common/themes';

const IconSend = ({ onClick, className, id, width = 24, height = 24, iconColor = s8sColor.neutral.gray800, disabled }: any) => {
	const [isHover, setIsHover] = useState(false);

	return (
		<svg
			id={id}
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			onMouseEnter={() => {
				setIsHover(true);
			}}
			onMouseLeave={() => {
				setIsHover(false);
			}}
			onClick={() => {
				if (disabled) {
					return;
				}
				onClick();
			}}
			className={className}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.7412 3.06787C20.2518 2.8699 20.8262 3.12283 21.0244 3.6333C21.1139 3.86399 21.1139 4.12039 21.0244 4.35107L14.5469 21.0571C14.3489 21.5676 13.7742 21.8212 13.2637 21.6235C12.9797 21.5134 12.7615 21.2782 12.6729 20.9868L10.4404 13.6519L3.10449 11.4194C2.58059 11.2598 2.28487 10.7051 2.44434 10.1812C2.53303 9.8898 2.7512 9.65551 3.03516 9.54541L19.7412 3.06787ZM12.3574 13.1362L13.7354 17.6636L17.4746 8.01904L12.3574 13.1362ZM6.42773 10.356L10.9551 11.7339L16.0723 6.61572L6.42773 10.356Z"
				fill={disabled ? color.$8 : isHover ? s8sColor.neutral.gray200 : iconColor}
			/>
		</svg>
	);
};

export default IconSend;
